module.exports = __webpack_public_path__ + "src/assets/img/cpx.c87290ba.jpg";